import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    popFilterProductTitleOrKeywords,
    popFilterLocationBoxOrPincode,
    pushFilterProductTitleOrKeywords, selectProductTitleOrKeywords
} from '../DataStore/Slices/filterSlice';
import mapValues from 'lodash/mapValues';
import LayersClearIcon from '@material-ui/icons/Clear';
import { nanoid } from 'nanoid'
import { getAllProductDocument } from '../Backend/firebase/product';
import { pushFilterProductRecords } from '../DataStore/Slices/productSlice';
import { getAllEmployerDocument } from '../Backend/firebase/user';

const SearchProducts = ({ getAlert }) => {
    const { register, handleSubmit, setValue } = useForm();
    const history = useHistory();
    const dispatch = useDispatch();
    const productTitleOrKeywordFilter = useSelector(selectProductTitleOrKeywords);
    const [isClear, setIsClear] = useState(false);

    useEffect(() => {
        loadSearchBox();
    }, []);

    useEffect(() => {
        loadSearchBox();
    }, [productTitleOrKeywordFilter]);

    const loadSearchBox = () => {
        var searchData = {
            productTitleOrKeywords: '',
            locationBoxOrPincode: ''
        }

        if (productTitleOrKeywordFilter.ProductName !== '' && productTitleOrKeywordFilter.ProductName !== '0') {
            searchData.productTitleOrKeywords = productTitleOrKeywordFilter.ProductName;
        }

        setTimeout(() => {
            mapValues(searchData, (value, key) => setValue(key, value));
        });
    };

    const onSearch = async (data) => {
        if (!isClear) {
            setIsClear(false);
            if (window.location.pathname === '/products') {
                var ProductName = data.productTitleOrKeywords === '' ? '0' : data.productTitleOrKeywords;
                if ((data.productTitleOrKeywords !== '' || productTitleOrKeywordFilter.ProductName !== '0') && data.productTitleOrKeywords !== productTitleOrKeywordFilter.ProductName) {
                    dispatch(pushFilterProductTitleOrKeywords({
                        ProductName
                    }));
                }
            } else {
                var ProductName = data.productTitleOrKeywords === '' ? '0' : data.productTitleOrKeywords;
                if ((data.productTitleOrKeywords !== '' || productTitleOrKeywordFilter.ProductName !== '0') && data.productTitleOrKeywords !== productTitleOrKeywordFilter.ProductName) {
                    dispatch(pushFilterProductTitleOrKeywords({
                        ProductName
                    }));
                }

                let uniqueId = nanoid();
                history.push(`/products/${uniqueId}`);
            }
        }
        setIsClear(false);
    };

    const clearFields = async () => {
        setIsClear(true);
        dispatch(popFilterProductTitleOrKeywords());
        dispatch(popFilterLocationBoxOrPincode());
        var searchData = {
            productTitleOrKeywords: '',
            locationBoxOrPincode: ''
        }
        setTimeout(() => {
            mapValues(searchData, (value, key) => setValue(key, value));
        });

        try {
            const getAllProducts = await getAllProductDocument();
            const getRetailer = await getAllEmployerDocument();
            let records = []
            getAllProducts?.map((productDoc) => {
                const userId = productDoc.userId;
                getRetailer?.map((retailerDoc) => {
                    if(retailerDoc.uid == userId) {
                        let objRecord = {}
                        Object.assign(objRecord, productDoc,  {storeName: retailerDoc.storeName, storeAddress: retailerDoc.storeAddress})
                        records.push(objRecord)
                    }
                });
            });
            dispatch(pushFilterProductRecords({
                products: records
            }));
        } catch(error) {
            console.log("Error Occur in Search Products", error)
        }
    }

    return (
        <>
            <form>
                <div className="row">
                    <div className="col-md-12 mt-1">
                        <div className="d-flex justify-content-center w-100 align-items-center homeScreen__searchBox">
                            <input type="text" placeholder="Brand Name, Compositions, chemist store" className="border-0"
                                name="productTitleOrKeywords" ref={register} />
                                <div className="d-flex btn__action">
                                    <Button type="button" variant="outlined" className="navbar__btnClear" size="small"
                                        style={{ marginRight: '5px', background: '#fff',
                                        border: 'solid 1px #fff',
                                        padding: '3px 2px',
                                        minWidth: '32px', }} onClick={clearFields}>
                                        <LayersClearIcon className="mr-2" fontSize="small" />&nbsp;
                                    </Button>
                                    <Button type="button" variant="contained" color="primary" className="navbar__btnSearch" size="small"
                                        onClick={handleSubmit(onSearch)}>
                                        <SearchIcon className="mr-2" fontSize="small" />
                                    </Button>
                                </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6 mt-1">
                        <div className="d-flex justify-content-center w-100 align-items-center homeScreen__searchBox">
                            <LocationOnIcon className="mr-2" />
                            <input type="text" placeholder="Place or zipcode" className="border-0"
                                name="locationBoxOrPincode" ref={register} />
                        </div>
                    </div> */}
                    {/* <div className="col-md-12 mt-2 homeScreen__searchBtn">
                        <Button type="button" variant="contained" color="primary" className="navbar__btnSearch" size="small"
                            style={{ marginRight: '5px' }} onClick={clearFields}>
                            <LayersClearIcon className="mr-2" fontSize="small" />&nbsp;Clear
                        </Button>
                        <Button type="submit" variant="contained" color="primary" 
                        className="navbar__btnSearch" size="small" onClick={handleSubmit(onSearch)}>
                            <SearchIcon className="mr-2" fontSize="small" />&nbsp;Search
                        </Button>
                    </div> */}
                </div>
            </form>
        </>
    )
}

export default SearchProducts
